import { updatePayment, updateSupplementPayment } from '@/api/demand/demand'

// https://confluence.mobvista.com/pages/viewpage.action?pageId=49642221

const getInfo = () => {
  const payment = {
    currency: 1, // 币种
    exchange_rate: 6.6, // 汇率
    cost: '', // 增加Cost
    revenue: '', // 增加Rev
    // revenue
    revenue_usd: '',
    revenue_cny: '',
    // cost
    cost_usd: '',
    cost_cny: '',
    is_prepaid: 1, // 预付
    prepaid_percent: '', // 预付比例
    crm_contract_no: '', // CRM合同编号
    invoice_id: '', // Related invoice
  }
  return {
    id: '', // 需求 id
    payment_id: '', // 结算 id
    category: 'design', // 只有设计项目才需要编辑结算数据
    is_pay: 1, // 是否付费
    ...payment,
  }
}

const advertiser = {
  namespaced: true,

  state: {
    info: getInfo(),

    dialog: {
      title: '编辑结算数据',
      visible: false,
      type: 'payment', // payment, close-pay
    },

    type: 'add',
    loading: false,

    options: null,
  },

  mutations: {
    updateLoading(state, value) {
      state.loading = value
    },
  },

  actions: {
    openDialog({ state, dispatch }, config) {
      state.dialog = {
        ...state.dialog,
        ...(config || {}),
        visible: true,
      }
    },

    closeDialog({ state }) {
      state.dialog.visible = false
    },

    updateInfo({ state }, info) {
      state.info = {
        ...state.info,
        ...info,
      }
    },

    resetInfo({ state }) {
      state.info = getInfo()
    },

    async update({ state }) {
      if (state.dialog.type === 'close-pay') {
        return updateSupplementPayment({
          payment_id: state.info.payment_id,
          cost: Number(state.info.cost),
          revenue: Number(state.info.revenue),
        })
      }
      const isUsd = state.info.currency === 1
      const payment = {
        currency: state.info.currency,
        exchange_rate: state.info.exchange_rate,
        is_prepaid: state.info.is_prepaid,
        revenue: isUsd ? state.info.revenue_usd : state.info.revenue_cny,
        cost: isUsd ? state.info.cost_usd : state.info.cost_cny,
        crm_contract_no: state.info.crm_contract_no,
      }
      if (payment.is_prepaid === 1) {
        payment.prepaid_percent = state.info.prepaid_percent || 0
      }
      if (state.info.invoice_id) {
        payment.invoice_id = state.info.invoice_id
      }
      const params = {
        id: state.info.id,
        is_pay: state.info.is_pay,
      }
      if (state.info.is_pay === 1) {
        params.payment = payment
      }
      return updatePayment(params)
    },
  },
}

export default advertiser
